import data from "../../../../../src/Truncate.docs.json";
import * as React from 'react';
export default {
  data,
  React
};